import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TextInput from '../form/TextInput';
import TextArea from '../form/TextArea';
import createEditor from '../form/ComponentEditor';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import classNames from "classnames";
import ComponentField from "../form/ComponentField";
import RuleBookForm from "./forms/RuleBookForm";
import RuleBookList from "./lists/RuleBookList";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class RuleBookEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Játékszabályok"
                    footer={[
                        <Button
                            key="0"
                            className="pull-left"
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
					]}
                >
                    <RuleBookList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Játékszabály"
                    footer={[
						<Button
							key="0"
							disabled={!this.props.dirty}
							className="pull-right"
							color="primary"
							onClick={this.saveForm}
						>
							Mentés
						</Button>
                    ]}
                >
                    <RuleBookForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}
export default createEditor({
    componentName: "RuleBook",
    WrappedComponent: RuleBookEditor,
    props: {
        view: "admin"
    }
});

